import { defineMessages } from 'react-intl';

export default defineMessages({
    pageHeaderTitleAdacMed: {
        id: 'claim.views.service-confirmation.ADAC Ambulance service',
        defaultMessage: 'ADAC Ambulance service',
    },
    pageHeaderTitleAdacKfzGermany: {
        id: 'claim.views.service-confirmation.Vehicle incident Germany',
        defaultMessage: 'Vehicle incident Germany',
    },
    pageHeaderTitleAdacKfzAbroad: {
        id: 'claim.views.service-confirmation.Vehicle incident Abroad',
        defaultMessage: 'Vehicle incident Abroad'
    },
    loginHeaderAdacMed: {
        id: 'adac.login-page.Log in',
        defaultMessage: 'Log in'
    },
    loginHeaderAdacKfzGermany: {
        id: 'claim.views.service-confirmation.Vehicle incident Germany',
        defaultMessage: 'Vehicle incident Germany',
    },
    loginHeaderAdacKfzAbroad: {
        id: 'claim.views.service-confirmation.Vehicle incident Abroad',
        defaultMessage: 'Vehicle incident Abroad'
    },
    toGoToDetailsAdacMed: {
        id: 'adac.login-page.To go to the details of your claim please enter the information provided during phone call',
        defaultMessage: 'To go to the details of your claim please enter the information provided during the confirmation call'
    },
    toGoToDetailsAdacKfzGermany: {
        id: 'adac.login-page.Please enter the last 5 digits of your membership number and your car registration number to access our online service.',
        defaultMessage: 'Please enter the last 5 digits of your membership number and your car registration number to access our online service.'
    },
    toGoToDetailsAdacKfzAbroad: {
        id: 'adac.login-page.Please enter the last 5 digits of your membership number and your car registration number to access our online service.',
        defaultMessage: 'Please enter the last 5 digits of your membership number and your car registration number to access our online service.'
    },
    telefonNumberAdacMed: {
        id: 'adac.header.modal-contact-adac.Phone number Med',
        defaultMessage: '+4989767676'
    },
    telefonNumberAdacKfzGermany: {
        id: 'adac.header.modal-contact-adac.Phone number Vehicle Germany',
        defaultMessage: '+4989767670'
    },
    telefonNumberAdacKfzAbroad: {
        id: 'adac.header.modal-contact-adac.Phone number Vehicle Abroad',
        defaultMessage: '+4989222222'
    },
    emailAddressAdacMed: {
        id: 'adac.header.modal-contact-adac.Email',
        defaultMessage: 'Ambulance@adac.de'
    },
    emailAddressAdacKfzGermany: {
        id: 'adac.header.modal-contact-adac.Email Vehicle Germany',
        defaultMessage: 'SB-Inland-Hilfe@adac.de'
    },
    emailAddressAdacKfzAbroad: {
        id: 'adac.header.modal-contact-adac.Email Vehicle Abroad',
        defaultMessage: 'web-notruf@adac.de'
    },
    signDocumentAdacMed: {
        id: 'adac.labels.components.SignDocumentComponent.Sign Med',
        defaultMessage: 'Sign'
    },
    signDocumentAdacKfzGermany: {
        id: 'adac.labels.components.SignDocumentComponent.Sign Vehicle Germany',
        defaultMessage: 'Sign'
    },
    signDocumentAdacKfzAbroad: {
        id: 'adac.labels.components.SignDocumentComponent.Sign Vehicle Abroad',
        defaultMessage: 'Sign'
    },
    
});
